import { all, takeLatest, call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';
import { navigate } from '@reach/router';
import { Paths } from '@/pages/routers';
import { executeAfterToast } from '@/utils';
import {
  fetchServiceCategoriesActions,
  fetchServiceCategoryByIdActions,
  createServiceCategoryActions,
  editServiceCategoryActions,
  deleteServiceCategoryActions,
} from '@/redux/actions/service-directory/service-category';
import { ServiceCategoryInstance } from '@/services/service-directory/service-category';

export function* fetchServiceCategoriesSaga(action: ActionType<typeof fetchServiceCategoriesActions.request>) {
  try {
    const { entityId } = action.payload;
    const data = yield call(ServiceCategoryInstance.fetchServiceCategories, entityId);

    yield put(fetchServiceCategoriesActions.success(data));
  } catch (error) {
    yield put(fetchServiceCategoriesActions.failure(error));
  }
}

export function* fetchServiceCategorySaga(action: ActionType<typeof fetchServiceCategoryByIdActions.request>) {
  try {
    const { id } = action.payload;
    const serviceCategory = yield call(ServiceCategoryInstance.fetchServiceCategory, id);
    yield put(fetchServiceCategoryByIdActions.success(serviceCategory));
  } catch (err) {
    yield put(fetchServiceCategoryByIdActions.failure(err));
  }
}

export function* createServiceCategorySaga(action: ActionType<typeof createServiceCategoryActions.request>) {
  try {
    const { serviceCategory } = action.payload;
    yield call(ServiceCategoryInstance.createServiceCategory, serviceCategory);
    yield put(createServiceCategoryActions.success());
    executeAfterToast(() => navigate(`${Paths.Dashboard}${Paths.ServiceCategories}`));
  } catch (err) {
    yield put(createServiceCategoryActions.failure(err));
  }
}

export function* editServiceCategorySaga(action: ActionType<typeof editServiceCategoryActions.request>) {
  try {
    const { id, serviceCategory } = action.payload;

    yield call(ServiceCategoryInstance.updateServiceCategory, id, serviceCategory);
    yield put(editServiceCategoryActions.success());
    executeAfterToast(() => navigate(`${Paths.Dashboard}${Paths.ServiceCategories}`));
  } catch (err) {
    yield put(editServiceCategoryActions.failure(err));
  }
}

export function* deleteServiceCategorySaga(action: ActionType<typeof deleteServiceCategoryActions.request>) {
  try {
    const { id } = action.payload;

    yield call(ServiceCategoryInstance.deleteServiceCategory, id);
    yield put(deleteServiceCategoryActions.success());
    executeAfterToast(() => navigate(`${Paths.Dashboard}${Paths.ServiceCategories}`));
  } catch (err) {
    yield put(deleteServiceCategoryActions.failure(err));
  }
}

export default function* root() {
  yield all([
    takeLatest(fetchServiceCategoriesActions.request.type, fetchServiceCategoriesSaga),
    takeLatest(fetchServiceCategoryByIdActions.request.type, fetchServiceCategorySaga),
    takeLatest(createServiceCategoryActions.request.type, createServiceCategorySaga),
    takeLatest(editServiceCategoryActions.request.type, editServiceCategorySaga),
    takeLatest(deleteServiceCategoryActions.request.type, deleteServiceCategorySaga),
  ]);
}
